import React from 'react';

import Button from '../components/Button';
import Hero from '../components/Hero';
import IconContentBlock from '../components/IconContentBlock';
import IndustryList from '../components/IndustryList';
import ContentBlock from '../components/ContentBlock';
import Section from '../components/Section';
import SectionHero from '../components/SectionHero';

const examples = [
  {
    title: 'Gatsby eCommerce',
    description:
      'Build your own Gatsby powered online store, with orders automatically fulfilled from Printful.',
    cta: 'View repository',
    ctaTo: 'https://github.com/GraphCMS/gatsby-graphcms-ecommerce-starter',
    icon: 'GATSBY',
  },
  {
    title: 'Gatsby + GraphCMS',
    description:
      'Watch Scott Spence get started with Gatsby and GraphCMS in this short video tutorial.',
    cta: 'Watch video',
    ctaTo: 'https://www.youtube.com/watch?v=S9JeASI5tck',
    icon: 'YOUTUBE',
  },
  {
    title: 'Gatsby Image + GraphCMS',
    description:
      'Automatically resize, compress and lazy load images with this Gatsby Image like React component.',
    cta: 'View repository',
    ctaTo: 'https://github.com/GraphCMS/graphcms-image',
    icon: 'REACT',
  },
];

const GatsbyCMSBaseTemplate = ({ pageContext: { page } }) => {
  const { usps, contentBlocks } = page;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Try GraphCMS for free &#8594;
          </Button>
        </Hero>
      </Section>
      <Section colour="light">
        <SectionHero noHr title="Why GraphCMS?" />
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>
      <Section>
        <div className="md:flex md:flex-wrap -mx-6">
          {usps.map(IconContentBlock)}
        </div>
        <div className="mt-24">
          <SectionHero
            title="Bring Your Own Frontend"
            description="Build amazing frontend experiences with the blazing fast GraphCMS content API. Build with Gatsby, Apollo, Netlify and even plain old HTTP."
            ctas={[
              {
                href: 'https://app.graphcms.com/signup',
                label: 'Get started for free',
              },
            ]}
          />
        </div>
        <div className="mt-24 md:flex md:flex-wrap -mx-6">
          {examples.map(IconContentBlock)}
        </div>
      </Section>
    </React.Fragment>
  );
};

export default GatsbyCMSBaseTemplate;
